import { Theme } from '@mui/material';
import { brand } from '../../themes';

// Altura/radius compartilhados entre o controle "Ordenar por" (OrdenarPorControl) e o campo de
// busca (ListagemBuscaField) — os dois precisam ficar visualmente pareados na mesma linha da
// barra de ferramentas.
export const CONTROLE_ALTURA = 60;
// No celular os 60px de altura ficam grossos demais pra pouco valor de informação (ver
// OrdenarPorControl/ListagemBuscaField) — usado só abaixo do breakpoint 'sm'.
export const CONTROLE_ALTURA_MOBILE = 44;
export const CONTROLE_RADIUS = '12px';

// Estilo padrão da coluna de valor monetário (ex.: preço de venda) nas listagens — negrito e
// verde, pra destacar o número principal da linha.
export const valorMonetarioSx = {
  fontSize: '0.8125rem',
  fontWeight: 700,
  color: 'success.dark' as const,
};

// Estilo padrão de uma coluna de "código" (código interno, código de barras etc.) — navy fixo
// da marca no tema claro. `brand.menuBase` só tem contraste em cima de fundo claro: no tema
// escuro (página inteira escura, não só a sidebar) esse mesmo navy fica ilegível, por isso o
// fallback pro tom claro da mesma família de cor.
export const codigoInternoSx = (theme: Theme) => ({
  fontSize: '0.875rem',
  color: theme.palette.mode === 'dark' ? brand.primaryLight : brand.menuBase,
});

// Paper que envolve a tabela — radius 14px, sem sombra própria (usa a do tema).
export const paperListagemSx = (theme: Theme) => ({
  position: 'relative' as const,
  borderRadius: '14px',
  overflow: 'hidden' as const,
  border: `1px solid ${theme.torq.border.default}`,
  boxShadow: theme.torq.dialogShadow,
});

// `borderRadius` igual ao do Paper (não só `overflow:hidden` nele) — sem isso, o fundo colorido
// do cabeçalho da tabela fica com um respiro visível antes da curva do canto arredondado em vez
// de acompanhá-la. `cheia` decide entre altura fixa (página cheia ou carregando) e altura
// automática (página curta/parcial, pro fundo acompanhar a quantidade real de itens).
export const tableContainerListagemSx = (
  containerHeight: number | undefined,
  cheia: boolean,
  fallbackMaxHeight = 'calc(100vh - 220px)'
) => ({
  height: cheia
    ? (containerHeight ? `${containerHeight}px` : fallbackMaxHeight)
    : 'auto',
  maxHeight: containerHeight ? `${containerHeight}px` : fallbackMaxHeight,
  overflow: 'auto' as const,
  borderRadius: '14px',
});
